import { BaseModel } from './BaseModel';

export class ConsentType extends BaseModel {
  static get entity() {
    return 'consent_types';
  }

  static get fk() {
    return 'consent_type_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      description: this.attr(null),
      additional_message: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params) {
        return this.get(`/consent-types`, { params });
      },
      fetchById(id) {
        return this.get(`/consent-types/${id}`);
      }
    }
  };
}

export default ConsentType;
